<mat-card *ngIf="teamMembers.length > 0" nestedCard animated>
    <mat-card-title>{{ cardTitle }}</mat-card-title>
    <mat-card-content>
        <div class="form-group autocomplete-group">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-icon [svgIcon]="'v2:fi-br-search'" matPrefix></mat-icon>
                <input type="text"
                       aria-label="Search"
                       matInput
                       [matAutocomplete]="auto"
                       [formControl]="searchControl"
                       [placeholder]="'Find existing....'"
                       (keydown)="$event.stopPropagation()">
                <mat-autocomplete [class]="'v2-panel'" autoActiveFirstOption #auto="matAutocomplete">
                    <ng-template [ngForOf]="filteredTeamMembers" let-result ngFor>
                        <mat-option tabindex="0"
                                    [class.option-selected]="selectedEmails.isSelected(result.email)"
                                    [style.height.px]="itemHeight"
                                    [value]="result.id">
                            <span matListItemTitle>{{ result.name }}</span>
                            <span [innerHTML]="(result.propertyManagementCompanyUser ? 'Property Manager' : 'Community Manager') + ' • ' + result.email" matListItemLine></span>
                            <mat-icon [svgIcon]="'v2:fi-br-check'" matIconSuffix></mat-icon>
                        </mat-option>
                    </ng-template>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </mat-card-content>
</mat-card>
